import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import SEO from "@/components/site/SEO";

const faqs = [
  { q: "What is a real estate commission advance?", a: "A commission advance gives real estate agents access to a portion of their expected commission before closing." },
  { q: "Is this a loan?", a: "We present it as a commission advance based on your pending commission. Note: final legal wording should be reviewed by counsel." },
  { q: "Do you check credit?", a: "No traditional credit check is required for the demo offer. Eligibility is based on transaction details and verification." },
  { q: "How much can I request?", a: "Agents may request up to 75% of their expected net commission, subject to review and approval." },
  { q: "How fast can I receive funds?", a: "When documents are complete and the transaction is verified, funding may be available as soon as the same business day." },
  { q: "What documents do I need?", a: "Purchase contract, commission agreement, valid ID, and supporting transaction documentation." },
  { q: "How is repayment handled?", a: "Repayment is typically handled from the commission at closing through the broker, closing officer, or settlement process." },
];

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <SEO
        title="FAQ"
        description="Answers to common questions about real estate commission advances — credit checks, repayment, timing, and required documents."
        path="/faq"
      />
      <section className="gradient-champagne py-20 text-center">
        <span className="overline">FAQ</span>
        <h1 className="font-serif-lux text-5xl sm:text-6xl mt-5 px-6">Frequently Asked Questions</h1>
      </section>
      <section className="max-w-3xl mx-auto px-6 py-16">
        <Accordion type="single" collapsible>
          {faqs.map((f) => (
            <AccordionItem key={f.q} value={f.q} className="border-b border-[#E8DFD8]">
              <AccordionTrigger data-testid={`faq-page-q-${f.q}`} className="font-serif-lux text-xl text-left hover:no-underline hover:text-[#5A3B31]">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5A3B31] leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}
